let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3sflu"), load("5hFEw"), load("7YFVd"), load("kpINU"), load("amDM8"), load("ftJgg"), load("6c9wI")]).then(() => parcelRequire('ffp8s'));